import React from 'react';
import './serum-library.scss';
import { ToolbarSimple } from '../../components';
import { ScrollView } from 'devextreme-react';

const Index = () => {
  return (
    <ScrollView className='view-wrapper-scroll'>
      <ToolbarSimple title='Seroteca'></ToolbarSimple>
    </ScrollView>
  );
};

export default Index;
